interface IParameters {
  clients: string | null;
  excludeFromNegotiations: boolean;
  showBelongToPortafolio: boolean;
  negotiations_clients: string | null;
  statusNegotiations: string | null;
}
export interface IMonitorsFilters {
  parameters: IParameters;
}

class MonitorsFiltersClass implements IMonitorsFilters {
  parameters: IParameters;

  constructor(parameters: any) {
    this.parameters = parameters;
  }
}

export default MonitorsFiltersClass;
